import { restRequest } from 'core/utils/backend-service';
import { OperatorCustomNotification } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import {
    CustomAlarmDefinitionApi,
    OperatorCustomNotificationWriteApi,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.api';
import {
    buildOperatorCustomNotificationEndpoint,
    buildOperatorCustomNotificationsEndpoint,
    OPERATOR_CUSTOM_NOTIFICATIONS_ACTIVE_ENDPOINT,
    OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.constants';
import {
    mapOperatorCustomNotificationFromApi,
    mapOperatorCustomNotificationsFromApi,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.mapper';
export const getOperatorCustomNotifications = (showInactive: boolean): Promise<OperatorCustomNotification[]> =>
    restRequest('GET', buildOperatorCustomNotificationsEndpoint(showInactive))
        .then((response) => response.json() as Promise<CustomAlarmDefinitionApi[]>)
        .then(mapOperatorCustomNotificationsFromApi);

export const getOperatorCustomNotificationById = (id: string): Promise<OperatorCustomNotification> =>
    restRequest('GET', buildOperatorCustomNotificationEndpoint(id))
        .then((response) => response.json() as Promise<CustomAlarmDefinitionApi>)
        .then(mapOperatorCustomNotificationFromApi);

export const updateOperatorCustomNotificationsActiveStatus = (ids: string[], active: boolean): Promise<void> =>
    restRequest('PATCH', OPERATOR_CUSTOM_NOTIFICATIONS_ACTIVE_ENDPOINT, {
        body: { ids, active },
    }).then(() => undefined);

export const deleteOperatorCustomNotifications = (ids: string[]): Promise<void> =>
    restRequest('DELETE', OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT, {
        body: { ids },
    }).then(() => undefined);

export const createOperatorCustomNotification = (payload: OperatorCustomNotificationWriteApi): Promise<string> =>
    restRequest('POST', OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT, { body: payload }).then(
        (response) => response.json() as Promise<string>
    );

export const updateOperatorCustomNotification = (
    payload: OperatorCustomNotificationWriteApi,
    id: string
): Promise<void> =>
    restRequest('PUT', buildOperatorCustomNotificationEndpoint(id), { body: payload }).then(() => undefined);
